import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { FooterCmp, FooterProps } from "./Footer"

interface FooterWrapperProps {
  blok: FooterProps & blokType
  landingFooter?: boolean
}

const Footer: React.FC<FooterWrapperProps> = ({ blok, landingFooter }) => (
  <SbEditable content={blok}>
    <FooterCmp
      footer_menu={blok.footer_menu}
      footer_cta={blok.footer_cta}
      legal={blok.legal}
      copyright={blok.copyright}
      footer_social={blok.footer_social}
      landingFooter={landingFooter || false}
      legacy={blok.legacy}
    />
  </SbEditable>
)



export default Footer
